import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import FocusTrap from 'focus-trap-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SearchActionTypes } from '@state/features/common.types';
import Logo from '@stone/ui/logo/Logo';
import SearchContainer from '@stone/components/search/SearchContainer';
import classNames from 'classnames';
import useScrollDirection from '@utils/useScrollDirection';
import SearchCloseBtn from './SearchCloseBtn';
const SearchDialog = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { showSearch, resultsType, fromQuery, inputSearch } = useSelector((state) => state.search);
    // * ANCHOR - USE STATE --------------------------------------------------------------------------------------------------------------------------------------
    const [scrollContext, setScrollContext] = useState();
    const scrolldirection = useScrollDirection({ initialDirection: 'down', scrollContext: scrollContext });
    useEffect(() => {
        toggleShow(props.isOpen);
    }, [props.isOpen]);
    // open search after fetching data (only from query)
    useEffect(() => {
        if (fromQuery && props.searchData && inputSearch !== '') {
            toggleShow(true);
            props.handleClose();
            if (inputSearch.length >= parseInt(props.searchData.minSearchChars)) {
                dispatch({
                    type: SearchActionTypes.FETCH_SEARCH,
                    payload: {
                        resultsType: 'REFINE',
                    },
                });
            }
        }
    }, [inputSearch, fromQuery, props.searchData]);
    const toggleShow = (show) => {
        if (show === showSearch)
            return;
        dispatch({
            type: SearchActionTypes.TOGGLE_SEARCH,
            payload: show,
        });
    };
    return (React.createElement("div", { className: "search-modal-dialog" }, showSearch &&
        createPortal(React.createElement(FocusTrap, { focusTrapOptions: {
                allowOutsideClick: true,
                clickOutsideDeactivates: true,
                initialFocus: '#searchLabel',
                // initialFocus: () => inputRef.current,
            } },
            React.createElement("div", { className: classNames(['search-modal', { 'with-results': resultsType }, { 'scroll-up': scrolldirection === 'up' }]), ref: setScrollContext },
                React.createElement("div", { className: "search-modal-inner" },
                    React.createElement("div", { className: "header-logo" },
                        React.createElement(Logo, { context: 'header', id: "main", title: t('global.homepage') })),
                    React.createElement(SearchCloseBtn, { handleClose: props.handleClose }),
                    React.createElement(SearchContainer, { searchData: props.searchData, handleClose: props.handleClose })),
                React.createElement("div", { onClick: () => props.handleClose(), "aria-hidden": "true", className: "search-overlay-close" }))), document.body)));
};
export default SearchDialog;
